// @ts-nocheck
import * as Types from "../../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type RotateWebhookSigningKeyMutationVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type RotateWebhookSigningKeyMutation = {
  __typename?: "Mutation";
  rotateWebhookSigningKey?: {
    __typename?: "WebhookSigningKey";
    id: string;
  } | null;
};

export const RotateWebhookSigningKeyDocument = gql`
  mutation RotateWebhookSigningKey($organizationSlug: ID!) {
    rotateWebhookSigningKey(organizationSlug: $organizationSlug) {
      id
    }
  }
`;
export type RotateWebhookSigningKeyMutationFn = Apollo.MutationFunction<
  RotateWebhookSigningKeyMutation,
  RotateWebhookSigningKeyMutationVariables
>;

/**
 * __useRotateWebhookSigningKeyMutation__
 *
 * To run a mutation, you first call `useRotateWebhookSigningKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRotateWebhookSigningKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rotateWebhookSigningKeyMutation, { data, loading, error }] = useRotateWebhookSigningKeyMutation({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useRotateWebhookSigningKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RotateWebhookSigningKeyMutation,
    RotateWebhookSigningKeyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RotateWebhookSigningKeyMutation,
    RotateWebhookSigningKeyMutationVariables
  >(RotateWebhookSigningKeyDocument, options);
}
export type RotateWebhookSigningKeyMutationHookResult = ReturnType<
  typeof useRotateWebhookSigningKeyMutation
>;
export type RotateWebhookSigningKeyMutationResult =
  Apollo.MutationResult<RotateWebhookSigningKeyMutation>;
export type RotateWebhookSigningKeyMutationOptions = Apollo.BaseMutationOptions<
  RotateWebhookSigningKeyMutation,
  RotateWebhookSigningKeyMutationVariables
>;
